module.exports = __webpack_public_path__ + "static/media/gt.7fe64e01.svg";